import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button, ButtonGroup, Col, Container, FloatingLabel, Form, Image, InputGroup, Row, Tab, Tabs, ToggleButton } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LoginInfo } from '../App.js';
import Birthday from '../domain/Birthday.ts';
import Email from '../domain/Email.js';
import HomePage from '../domain/HomePage.js';
import InstagramId from '../domain/InstagramId.js';
import Password from '../domain/Password.js';
import ProfileImage from '../domain/ProfileImage.js';
import SelfIntroduction from '../domain/SelfIntroduction.js';
import Sex from '../domain/Sex.js';
import TwitterId from '../domain/TwitterId.js';
import UserId from '../domain/UserId.js';
import UserInfo from '../domain/UserInfo.ts';
import AiWorksDisplayFlag from '../domain/R18DisplayFlag.js'
import UserName from '../domain/UserName.js';
import * as ImageUtil from '../service/ImageUtil.js';
import ApiFetch from './ApiFetch.js';
import Dialog from './Dialog.js';
import Footer from './Footer.js';
import Header from './Header.js';
import OnetimePassword from '../domain/OnetimePassword.js';
import CampaignMessage from './CampaignMessage.js';
import Category from './Category.js';
import R18DisplayFlag from '../domain/R18DisplayFlag.js';
import R18GDisplayFlag from '../domain/R18GDisplayFlag.js';
import DisplayId from '../domain/DisplayId.js';
import GitHubId from '../domain/GitHubId.js';
import HuggingFaceId from '../domain/HuggingFaceId.js';
import { useTranslation } from "react-i18next";
import { isLoggin } from '../service/LoginService.js';
import SexualExpressionDisplayFlag from '../domain/PG12DisplayFlag.js';
import Language from '../domain/Language.js';
import * as Icon from 'react-bootstrap-icons';
import PhoneNumber from '../domain/PhoneNumber.js';
import MuteButton from './MuteButton.js';
import Cropper from 'react-easy-crop';
import MisskeyId from '../domain/MisskeyId.js';

const Setting = (props) => {
    async function getUserInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserSetting(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getMuteList(userId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/mute/muteList/"+userId+"/"+page)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function update(userId,email,misskey,password,displayId,userName,homePage,twitterId,instagramId,githubId,huggingFaceId,sex,birthday,selfIntroduction,img,dialog){
        let userInfo = new UserInfo({userId:new UserId(userId),email:new Email(email),misskeyId:new MisskeyId(misskey),password:new Password(password),displayId:new DisplayId(displayId),userName:new UserName(userName),
            homePage:new HomePage(homePage),twitterId:new TwitterId(twitterId),instagramId:new InstagramId(instagramId),gitHubId:new GitHubId(githubId),
            huggingFaceId:new HuggingFaceId(huggingFaceId),sex:new Sex(sex),birthday:new Birthday(birthday),
            selfIntroduction:new SelfIntroduction(selfIntroduction),profileImage:new ProfileImage(img.startsWith("data:") ? img : "")})
        // 必須・文字数・パターン
        if(!userInfo.validate(dialog)){
            return false
        }
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/",userInfo.values).then((r)=>{
            return r.json().then((json)=>{
                if(!json.result){
                    dialog("エラー",json.errors)
                }
                return json.result
            })
        })
    }
    async function updateDisplaySetting(sexualExpression,r18,r18g,lang,dialog){
        let sexualExpressionDisplayFlag = new SexualExpressionDisplayFlag(sexualExpression)
        let r18DisplayFlag = new R18DisplayFlag(r18)
        let r18GDisplayFlag = new R18GDisplayFlag(r18g)
        let language = new Language(lang)
        // 必須・文字数・パターン
        if(!sexualExpressionDisplayFlag.validate(dialog)){
            return false
        }
        // 必須・文字数・パターン
        if(!r18DisplayFlag.validate(dialog)){
            return false
        }
        // 必須・文字数・パターン
        if(!r18GDisplayFlag.validate(dialog)){
            return false
        }
        // 言語
        if(!language.validate(dialog)){
            return false
        }
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my",
        {sexualExpressionDisplayFlag:sexualExpressionDisplayFlag.props,
        r18DisplayFlag:r18DisplayFlag.props,r18GDisplayFlag:r18GDisplayFlag.props,language:language.props}
        ).then((r)=>{
            return r.json().then((json)=>{
                if(!json.result){
                    dialog("エラー",json.errors)
                }
                return json.result
            })
        })
    }
    async function oneTimePasswordSend(email){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/onetime/password",{email:"dummy@example.com"})
            .then((r)=>r.json().then((json)=>{
                if(json.result){
                    dialog("確認","ワンタイムパスワードをメールアドレス宛に送信しました。届いた番号を入力してください。")
                    setOneTimePasswordSended(true)
                } else {
                    dialog("エラー",json.errors)
                    setOneTimePasswordSended(false)
                }
            return json.result
        }))
    }
    async function oneTimePasswordSendToPhoneNumber(phoneCountry,phoneNumber){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/onetime/sms",{phoneCountry:phoneCountry,phoneNumber:phoneNumber})
            .then((r)=>r.json().then((json)=>{
                if(json.result){
                    dialog("確認","ワンタイムパスワードを電話番号宛に送信しました。届いた番号を入力してください。")
                    setOneTimePasswordToPhoneNumberSended(true)
                } else {
                    dialog("エラー",json.errors)
                }
            return json.result
        }))
    }
    async function updatePassword(oldPassword,newPassword,newPasswordConfirm,onetimePassword,dialog){
        let oldPasswordObj = new Password(oldPassword)
        let newPasswordObj = new Password(newPassword)
        let newPasswordConfirmObj = new Password(newPasswordConfirm)
        let onetimePasswordObj = new OnetimePassword(onetimePassword)
        // 必須・文字数・パターン
        if(!oldPasswordObj.validate(dialog) || !newPasswordObj.validate(dialog) || !onetimePasswordObj.validate(dialog) || !newPasswordConfirmObj.validate(dialog)){
            return false
        }
        if(newPassword !== newPasswordConfirm){
            dialog("エラー","新パスワードと新パスワード再入力が異なります。")
            return false;
        }
        if(oldPassword === newPassword){
            dialog("エラー","旧パスワードと同じには設定できません。")
            return false;
        }
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/password/reset",{oldPassword:oldPasswordObj.props,newPassword:newPasswordObj.props,onetimePassword:onetimePasswordObj.props}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    dialog("確認","変更完了しました。")
                    document.getElementById("old-password").value = ""
                    document.getElementById("new-password").value = ""
                    document.getElementById("new-password-confirm").value = ""
                    document.getElementById("onetime-password").value = ""
                    setOneTimePasswordSended(false)
                } else {
                    dialog("エラー",json.errors)
                }
                return json.result
            })
        })
    }
    async function smsAuth(phoneCountry,phoneNumber,onetimePassword,dialog){
        let phoneNumberObj = new PhoneNumber({phoneCountry,phoneNumber})
        let onetimePasswordObj = new OnetimePassword(onetimePassword)
        // 必須・文字数・パターン
        if(!phoneNumberObj.validate(dialog) || !onetimePasswordObj.validate(dialog)){
            return false
        }
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sms/auth",{phoneNumber:phoneNumberObj.props,onetimePassword:onetimePasswordObj.props}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    dialog("確認","認証しました。")
                    setSMSCertified(true)
                    document.getElementById("phone-number").value = ""
                    document.getElementById("onetime-password-sms").value = ""
                    setOneTimePasswordToPhoneNumberSended(false)
                } else {
                    dialog("エラー",json.errors)
                }
                return json.result
            })
        })
    }
    async function deleteAccount(){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/login/deleteAccount",{}).then((r)=>{
            return r.json().then((json)=>{
                return json
            })
        })
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    // ナビゲート
    const navigate = useNavigate();

    const [oneTimePasswordSended, setOneTimePasswordSended] = useState(false)
    const [oneTimePasswordToPhoneNumberSended, setOneTimePasswordToPhoneNumberSended] = useState(false)
    const [phoneCountry,setPhoneCountry] = useState("jp")
    const [smsCertified,setSMSCertified] = useState(false)
    const [profileImage, setProfileImage] = useState("")
    const [srcImage, setSrcImage] = useState("")

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // フラグ
    const [sexualExpressionValue, setSexualExpressionValue] = useState('2') // 性的表現(軽微)
    const [r18Value, setR18Value] = useState('2')
    const [r18GValue, setR18GValue] = useState('2')
    const [userInfo, setUserInfo] = useState([])
    const [userSetting, setUserSetting] = useState([])
    const [sex, setSex] = useState(1)
    const [language, setLanguage] = useState(1)
    const [lock18, setLock18] = useState(false)
    const [muteList,setMuteList] = useState([])

    // 初期処理
    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = t("category.setting") + " - アワートAI"
        getUserInfo().then(r=>{
            setUserInfo(r)
            setSex(r.sex)
            setLock18(r.age < 18)
        })
        getUserSetting().then(r=>{
            setUserSetting(r)
            setSexualExpressionValue(String(r.data.sexual_expression_display_flag))
            setR18Value(String(r.data.r18_display_flag))
            setR18GValue(String(r.data.r18g_display_flag))
            setLanguage(String(r.data.language))
        })
    },[])

    useEffect(() => {
        // 画像が設定されている場合
        if(profileImage.startsWith("data:image/jpeg")){
            console.log("読み込み完了")
        }
    },[profileImage])

    // ログイン情報が取得出来たらプロフィール画像に設定
    useEffect(() => {
        if(loginInfo.result === false){
            navigate("/")
        }
        setProfileImage("//"+ApiFetch.IMG_HOST+"/profile/"+loginInfo.userId+"_m.jpg?"+loginInfo.hash)
    },[loginInfo])

    const radios = [
      { name: t("common.yes"), value: "1" },
      { name: t("common.no"), value: "2" },
    ]

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [showCropper,setShowCropper] = useState()
    const [cropTarget,setCropTarget] = useState()
    const [tempThumbnail,setTempThumbnail] = useState()
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
            let image = document.getElementById("load-image")
            let canvas = document.createElement("canvas")
            let ctx = canvas.getContext("2d")
            canvas.width = image.width
            canvas.height = image.height

            ctx.drawImage(image,0,0)

            const data = ctx.getImageData(croppedAreaPixels.x,croppedAreaPixels.y,croppedAreaPixels.width,croppedAreaPixels.height)

            canvas.width = croppedAreaPixels.width
            canvas.height = croppedAreaPixels.height

            ctx.putImageData(data,0,0)

            let thumb = canvas.toDataURL("image/png")

            setTempThumbnail(thumb)
      }, [])
    return (
    <div className="wrapper">
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <Container className='d-flex flex-row justify-content-center flex-wrap'>
        <Tabs defaultActiveKey="account" id="uncontrolled-tab-example" className="mt-3 mb-3 w-100" onSelect={(key) => {
            if(key === "mute"){
                getMuteList(loginInfo.userId,1).then(r => {
                    if(r.result){
                        setMuteList(r.data)
                    } else {
                        dialog(t("common.error"),r.errors)
                    }
                })
            }
        }}>
            <Tab eventKey="account" title={<><Icon.PersonFill /> {t("setting.account.title")}</>} className='w-100'>
                <Container>
                    <h3>{t("setting.account.title")}</h3>
                    <p className='d-inline '>{t("setting.account.profileImage")}</p><br />
                    <Container style={{textAlign:"center"}}>
                        <Image src={profileImage} style={{width:"200px",height:"200px",borderRadius:"100px",marginRight:"30px"}} />
                        <Image src={srcImage} id="load-image" style={{display:"none"}} />
                        <Button onClick={(e) => document.getElementById("file").click()}>{t("setting.account.selectImage")}</Button><br /><br />
                        <Form.Control type="file" accept=".jpg,.jpeg,.gif,.png,.webp" className='d-none' id="file" onChange={(e) => {
                            setShowCropper(true)
                            ImageUtil.loadImageBig(e.currentTarget.files,setSrcImage,false)
                            document.getElementById("file").value = ""
                        }} />
                    </Container>
                    {showCropper ? (
                        <Container>
                    <Cropper
                        classes={{containerClassName: "cropper-container"}}
                        image={srcImage}
                        crop={crop}
                        zoom={zoom}
                        aspect={cropTarget === "outside" ? 2 / 1 : 1 / 1}
                        onCropChange={setCrop}
                        onCropComplete={onCropComplete}
                        onZoomChange={setZoom}

                    />
                        <Container style={{position:"absolute",width:"300px",height:"110px",zIndex:3,left:window.innerWidth / 2 - 150,bottom:"20px",borderRadius:"10px",backgroundColor:"#EEEEEE"}} className="p-3">
                            <FloatingLabel controlId="crop-zoom" label="" className="mb-3"
                                style={{position:"absolute",zIndex:3,top:0,width:"90%",fontSize:"24px"}}
                            >
                                <Form.Range type="range" defaultValue={zoom} min={1} max={5} step={0.1} onChange={(e) => {
                                    setZoom(e.currentTarget.value)
                                }} />
                            </FloatingLabel>
                            <Button style={{position:"absolute",zIndex:3,left:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                setProfileImage(tempThumbnail)
                                setShowCropper(false)
                            }}>OK</Button>
                            <Button variant='secondary' style={{position:"absolute",zIndex:3,right:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                setShowCropper(false)
                            }}>Cancel</Button>
                            </Container>
                        </Container>
                    ) : ""}
                    <FloatingLabel controlId="display-id" label={t("setting.account.displayId")} className="mb-3">
                        <Form.Control type="text" defaultValue={userInfo.display_id} />
                    </FloatingLabel>
                    {t("setting.account.displayIdMessage")}<br />
                    {t("setting.account.characterString")}
                    <FloatingLabel controlId="name" label={t("setting.account.userName")} className="mb-3">
                        <Form.Control type="text" defaultValue={userInfo.user_name} />
                    </FloatingLabel>
                    <FloatingLabel controlId="email" label={t("setting.account.email")} className="mb-3">
                        <Form.Control type="email" defaultValue={userInfo.email} disabled />
                    </FloatingLabel>
                    <Image src="/img/misskey.png" width="20px" />Misskey ID(ourt AI)
                    <InputGroup className="mb-3">
                        <InputGroup.Text>sns.ourt-ai.work/@</InputGroup.Text>
                        <Form.Control
                            id="misskey"
                            placeholder="Misskey ID(ourt AI)"
                            defaultValue={userInfo.misskey_id}
                        />
                    </InputGroup>
                    <FloatingLabel controlId="hp" label={t("setting.account.homepage")} className="mb-3">
                        <Form.Control type="text" defaultValue={userInfo.homepage} />
                    </FloatingLabel>
                    <FloatingLabel controlId="twitter" label={t("setting.account.twitterId")} className="mb-3">
                        <Form.Control type="text" defaultValue={userInfo.twitter_id} />
                    </FloatingLabel>
                    <FloatingLabel controlId="instagram" label={t("setting.account.instagramId")} className="mb-3">
                        <Form.Control type="text" defaultValue={userInfo.instagram_id} />
                    </FloatingLabel>
                    <FloatingLabel controlId="github" label={t("setting.account.githubId")} className="mb-3">
                        <Form.Control type="text" defaultValue={userInfo.github_id} />
                    </FloatingLabel>
                    <FloatingLabel controlId="hugging-face" label={t("setting.account.huggingFaceId")} className="mb-3">
                        <Form.Control type="text" defaultValue={userInfo.huggingface_id} />
                    </FloatingLabel>
                    <p className='d-inline '>{t("setting.account.sex")} <span style={{fontSize:"12px",color:"#555555"}}>({t("setting.account.private")})</span></p>
                    <Form.Select id="sex" className="mb-3" value={sex} onChange={(e) => setSex(e.target.value)} disabled>
                        <option value="1">{t("setting.account.male")}</option>
                        <option value="2">{t("setting.account.female")}</option>
                    </Form.Select>
                    <FloatingLabel controlId="birthday" label={t("setting.account.birthday")} className="mb-3">
                        <Form.Control type="date" defaultValue={userInfo.birthday} disabled />
                    </FloatingLabel>
                    <FloatingLabel controlId="self‐introduction" label={t("setting.account.selfIntroduction")} style={{lineHeight:"20px"}} onInput={(e) =>{
                            let lineHeight = e.currentTarget.style.lineHeight.replace(/[^0-9.]+/,'')
                            let n = e.nativeEvent.target.value.match(/\n/g)
                            if(n === null){
                                n = 1
                            } else {
                                n = n.length + 1
                            }
                            e.currentTarget.style.height = lineHeight * n + 30 + "px"
                            document.querySelector(".textarea").style.height = lineHeight * n + 30 + "px"
                        }}>
                        <Form.Control
                            className='textarea'
                            as="textarea"
                            style={{ height: '100px' }}
                            defaultValue={userInfo.self_introduction}
                        />
                    </FloatingLabel>
                    <Button className="mt-3" onClick={() => update(
                    "userId",// ユーザIDはセッションで判断する
                    "test@example.com",// メールは更新しない
                    document.getElementById("misskey").value,
                    "p@ssw0rd",// パスワードは更新しない
                    document.getElementById("display-id").value,
                    document.getElementById("name").value,
                    document.getElementById("hp").value,
                    document.getElementById("twitter").value,
                    document.getElementById("instagram").value,
                    document.getElementById("github").value,
                    document.getElementById("hugging-face").value,
                    "1",// 性別は更新しない
                    "9999-12-31", // 誕生日も更新しない
                    document.getElementById("self‐introduction").value,
                    profileImage,
                    dialog
                    ).then((r)=>{
                        if(r){
                            isLoggin().then(json => {
                                setLoginInfo(json)
                            })
                            dialog("確認","変更が完了しました。")
                            //document.getElementById("logo").click();
                        }
                    })}>{t("setting.account.update")}</Button>
                </Container>
            </Tab>
            <Tab eventKey="display" title={<><Icon.DisplayFill /> {t("setting.displaySettings.title")}</>} style={{width:"100%"}}>
                <Container>
                    <h3>{t("setting.displaySettings.title")}</h3>
                    <Container className='d-flex flex-row justify-content-between mb-3' style={{width:"400px",display:"none"}}>
                        <p className='d-inline '>{t("setting.displaySettings.sexualExpression")} </p>
                        <ButtonGroup>
                            {radios.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`radio-sexual-expression-${idx}`}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name="radio-sexual-expression"
                                    value={radio.value}
                                    checked={sexualExpressionValue === radio.value}
                                    onChange={(e) => setSexualExpressionValue(e.currentTarget.value)}
                                    >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                    </Container>
                    <Container className='d-flex flex-row justify-content-between mb-3' style={{width:"400px"}}>
                        <p className='d-inline '>{t("setting.displaySettings.r18")} </p>
                        <ButtonGroup>
                            {radios.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`radio-r18-${idx}`}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name="radio-r18"
                                    value={radio.value}
                                    checked={r18Value === radio.value}
                                    onChange={(e) => setR18Value(e.currentTarget.value)}
                                    disabled={lock18}
                                    >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                    </Container>
                    <Container className='d-flex flex-row justify-content-between mb-3' style={{width:"400px"}}>
                        <p className='d-inline '>{t("setting.displaySettings.r18g")} </p>
                        <ButtonGroup>
                            {radios.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`radio-r18g-${idx}`}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name="radio-r18g"
                                    value={radio.value}
                                    checked={r18GValue === radio.value}
                                    onChange={(e) => setR18GValue(e.currentTarget.value)}
                                    disabled={lock18}
                                    >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                    </Container>
                    <Icon.Globe /><p className='d-inline '> Language</p>
                    <Form.Select id="language" className="mb-3" value={language} onChange={(e) => {
                            let language = e.target.value
                            i18n.changeLanguage(language)
                            setLanguage(language)
                        }}>
                        <option value="ja">日本語</option>
                        <option value="en">English</option>
                        <option value="zhtw">中文(繁體)</option>
                        <option value="zhCN">中文(简体)</option>
                        <option value="ko">한국어</option>
                    </Form.Select>
                    <Button className="mt-3" onClick={() => updateDisplaySetting(
                        sexualExpressionValue,
                        r18Value,
                        r18GValue,
                        language,
                        dialog
                        ).then((r)=>{
                            if(r){
                                dialog("確認","変更が完了しました。")
                                //document.getElementById("logo").click();
                            }
                        })}>{t("setting.displaySettings.apply")}</Button>
                    </Container>
            </Tab>
            <Tab eventKey="password" title={<><Icon.KeyFill /> {t("setting.passwordReset.title")}</>}>
                <Container className='mt-3 mb-3' style={{width:"100%"}}>
                    <h3>{t("setting.passwordReset.title")}</h3>
                    <FloatingLabel controlId="old-password" label={t("setting.passwordReset.password")} className="mb-3">
                            <Form.Control type="password" placeholder="" />
                    </FloatingLabel>
                    <FloatingLabel controlId="new-password" label={t("setting.passwordReset.newPassword")} className="mb-3">
                            <Form.Control type="password" placeholder="" autoComplete="new-password" />
                    </FloatingLabel>
                    <FloatingLabel controlId="new-password-confirm" label={t("setting.passwordReset.newPasswordConfirm")} className="mb-3">
                            <Form.Control type="password" placeholder="" />
                    </FloatingLabel>
                    <p>{t("setting.passwordReset.characterString")}</p>
                    <Button onClick={() => {
                        if(new Password(document.getElementById("old-password").value).validate(dialog,true)
                            && new Password(document.getElementById("new-password").value).validate(dialog,true)
                            && new Password(document.getElementById("new-password-confirm").value).validate(dialog,true)){

                            oneTimePasswordSend(document.getElementById("email").value)
                        }
                    }} className="mb-1">{t("setting.passwordReset.sendOnetimePassword")}</Button>
                    <div className="mb-3">{t("setting.passwordReset.sendMessage")}</div>
                    <FloatingLabel controlId="onetime-password" label="ワンタイムパスワード" style={{display:oneTimePasswordSended ? "block" : "none"}}>
                        <Form.Control type="number" cows="10" />
                    </FloatingLabel>
                    <Button onClick={() => {
                        updatePassword(
                            document.getElementById("old-password").value,
                            document.getElementById("new-password").value,
                            document.getElementById("new-password-confirm").value,
                            document.getElementById("onetime-password").value,
                            dialog
                        )
                    }} className="mt-3">{t("setting.passwordReset.update")}</Button>
                </Container>
            </Tab>
            <Tab eventKey="security" title={<><Icon.DoorClosedFill /> {t("setting.security.title")}</>}>
                <Container className='mt-3 mb-3' style={{width:"100%"}}>
                    <h3>{t("setting.security.smsAuth")}</h3>
                    {userInfo.sms_auth === 1 || smsCertified ? (<p>{t("common.certified")} <Icon.CheckCircleFill style={{color:"#1D9BF0"}} /></p>) : ""}
                    <Container className='p-0' style={{display:userInfo.sms_auth === 1 || smsCertified ? "none" : "block"}}>
                        <Form.Select id="phone-contry" className="mb-3" value={phoneCountry} onChange={(e) => setPhoneCountry(e.target.value)} disabled={oneTimePasswordToPhoneNumberSended}>
                            <option value="jp">+81 Japan</option>
                            <option value="tw">+886 Taiwan</option>
                            <option value="hk">+852 Hong Kong</option>
                            <option value="fr">+33 France</option>
                            <option value="th">+66 Thailand</option>
                            <option value="de">+49 Germany </option>
                        </Form.Select>
                        <FloatingLabel controlId="phone-number" label={t("setting.security.phoneNumber")} className="mb-3">
                            <Form.Control type="text" placeholder="" disabled={oneTimePasswordToPhoneNumberSended} />
                        </FloatingLabel>
                        <Button onClick={() => {
                            if(new PhoneNumber(document.getElementById("phone-number").value).validate(phoneCountry,dialog,true)){
                                oneTimePasswordSendToPhoneNumber(phoneCountry,document.getElementById("phone-number").value)
                            }
                        }} className="mb-1">{t("setting.security.sendOnetimePassword")}</Button>
                        <div className="mb-3">{t("setting.security.sendMessage")}</div>
                        <FloatingLabel controlId="onetime-password-sms" label="ワンタイムパスワード" style={{display:oneTimePasswordToPhoneNumberSended ? "block" : "none"}}>
                            <Form.Control type="number" cows="10" />
                        </FloatingLabel>
                        <Button onClick={() => {
                            smsAuth(
                                phoneCountry,
                                document.getElementById("phone-number").value,
                                document.getElementById("onetime-password-sms").value,
                                dialog
                            )
                        }} className="mt-3" disabled={!oneTimePasswordToPhoneNumberSended}>{t("setting.security.auth")}</Button>
                    </Container>
                </Container>
            </Tab>
            <Tab eventKey={"mute"} title={<><Icon.PersonX /> {t("common.muted")}</>}>
                <Row>
                {muteList.map((d,i) => {
                    return (
                        <Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="p-1" key={i}>
                            <Container className="p-1" style={{border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                                <div className='d-flex justify-content-start'>
                                    <div>
                                        <Link to={"/user/"+d.mute_target_user_id}><Image data-type="mute" data-observe="0" data-no={i} className="lazy" loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+d.mute_target_user_id+".jpg"} style={{width:"50px",height:"auto",borderRadius:"50%"}} /></Link>
                                    </div>
                                    <div className='p-3'>
                                        <Link to={"/user/"+d.mute_target_user_id} style={{textDecoration:"none",color:"#000000"}}>{d.user_name}</Link>
                                        <br />
                                        <div style={{cursor:"pointer",border:"1px solid #000000",display:"inline-block"}}>
                                            <MuteButton userId={d.mute_target_user_id} mute={d.mute} userName={d.user_name} />
                                        </div>
                                    </div>
                                </div>
                                <p>{d.self_introduction}</p>
                            </Container>
                        </Col>
                    )
                })}
                </Row>
            </Tab>
            <Tab eventKey="other" title={<><Icon.PersonBadge /> {t("setting.other.title")}</>}>
                <Button variant='outline-danger'
                onClick={() => dialog(t("common.info"),<>アカウントを削除しますか？<br />
                削除するには、「アカウント削除」と入力してください。<br />
                <FloatingLabel controlId="account-delete-input" label={"入力"} className="mb-3">
                    <Form.Control type="text" placeholder="" />
                </FloatingLabel>
                <Button variant='danger'
                onClick={() => {
                    let input = document.querySelector("#account-delete-input").value
                    if(input !== "アカウント削除"){
                        alert("入力が誤っています。")
                        return
                    }
                    deleteAccount().then(r => {
                        if(r.result){
                            dialog(t("common.info"),<>アカウントは削除されました。<br /><Button onClick={() => window.location.reload()}>OK</Button></>)
                        }
                    })
                }}
                >削除</Button>
                </>)}
                >アカウントの削除</Button>
            </Tab>
        </Tabs>
        </Container>
        <Footer />
    </div>
    )
}

export default Setting;
